module.exports = __webpack_public_path__ + "static/media/aragorn-main.1f4f7400.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Reconstructions/2D/aragorn-main.jpg
// module id = 469
// module chunks = 0